<template>
  <v-row class="pt-12">
    <v-col style="align-self: start">
      <app-pdf-preview
        :value="loading"
        :queryParams="$route.query"
        @loadDone="onLoadDone"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    }
  },

  mounted() {
    this.loading = true
  },

  methods: {
    onLoadDone() {
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
